import { render, staticRenderFns } from "./shipment_masterawb.vue?vue&type=template&id=656410a2&"
import script from "./shipment_masterawb.vue?vue&type=script&lang=js&"
export * from "./shipment_masterawb.vue?vue&type=script&lang=js&"
import style0 from "./shipment_masterawb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports